export default __webpack_public_path__ + "static/media/bell-ringing.0f2b89d5.svg";